import { DtRichText } from '@ow/ditto-core'

const { validation, transformer } = DtRichText

export { default as Render } from './render'
// export { default as Filter } from './filter'
export { validation, transformer }
